import React, {useEffect, useState} from 'react';
import '../../css/web/UserReviewPg.css';
import '../../css/web/UserPageRenew.css';
import '../../css/web/UserReviewRenew.css';
import noReviewPhoto from "../../assets/img/btorage_noimage.png";
import '../../css/web/HeartButton.css';
import {Link, useNavigate} from "react-router-dom";
import axios from '../../services/axiosInstance';
import {useTranslation} from "react-i18next";
import {BiSearch} from "react-icons/bi";
import commomHeader from "../../assets/img/commonHeader.png";
import SeoHelmet from "../../components/SeoHelmet";
import {Helmet} from "react-helmet-async";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";

function UserReviewPg() {
    const {t} = useTranslation();
    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');
    const [hasClickedMore, setHasClickedMore] = useState(false);
    const navigate = useNavigate();
    const [theme] = useTheme();

    const [reviewAllList, setReviewAllList] = useState([]);
    const [filteredReviews, setFilteredReviews] = useState([]);
    const [displayLimit, setDisplayLimit] = useState(30);
    const [searchText, setSearchText] = useState('');

    const selectReviewAllList = () =>
        axios({
            method: 'get',
            url: '/review/selectReviewAllList',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
        })
            .then((response) => {
                const sortedData = response.data.sort((a, b) => b.seqNum - a.seqNum);
                setReviewAllList(sortedData)
                setFilteredReviews(response.data.slice(0, displayLimit));
            })

    useEffect(() => {
        selectReviewAllList();
    }, [])

    const formatDate = (dateStr) => {
        if (dateStr.length !== 8) return "";
        return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6, 8)}`;
    }

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchText(value);
        const filtered = reviewAllList.filter(review =>
            review.title.toLowerCase().includes(value) ||
            review.country.toLowerCase().includes(value) ||
            review.shipco.toLowerCase().includes(value)
        );
        setFilteredReviews(filtered.slice(0, displayLimit));
    }

    const handleMore = () => {
        setDisplayLimit(prev => prev + 30);
        setFilteredReviews(reviewAllList.slice(0, displayLimit + 30));
        setHasClickedMore(true);
    }

    const newTextPrintFl = (regDate) => {
        // 오늘 날짜 객체를 생성
        const today = new Date();
        const todayFormatted = `${today.getFullYear()}${(today.getMonth() + 1).toString().padStart(2, '0')}${today.getDate().toString().padStart(2, '0')}`;
        // 입력된 날짜와 오늘 날짜를 비교
        return regDate === todayFormatted;
    };

    return (
        <div className="up-scope up-page" data-theme={theme}>

            <Helmet>
                <title>이용후기(Review)</title>
                <meta name="description" content="국가별 이용후기를 참고해보세요"/>
                <link rel="canonical" href="https://btorage.com/UserReviewPg"/>
                <meta property="og:url" content="https://btorage.com/UserReviewPg"/>
                <link rel="alternate" hrefLang="ko" href="https://btorage.com/UserReviewPg"/>
                <link rel="alternate" hrefLang="x-default" href="https://btorage.com/UserReviewPg"/>

                <link rel="icon" type="image/png" sizes="32x32" href="/bt_logo.png"/>
                <link rel="apple-touch-icon" href="/bt_logo.png"/>
                <meta property="og:type" content="website"/>
                <meta property="og:image" content="https://btorage.com/linkBanner.jpg"/>
                <meta property="og:image:width" content="1200"/>
                <meta property="og:image:height" content="630"/>
                <meta property="og:site_name" content="비토리지(Btorage)"/>
                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:image" content="https://btorage.com/linkBanner.jpg"/>
            </Helmet>

            <div className="up-head">
                <div className="up-head-l">
                    <img className="up-head-icon up-invert" src={commomHeader} alt="header"/>
                    <p className="up-head-title">{t(`rvHeader`)}</p>
                </div>
            </div>

            <div className="rv-top">
                <div className="rv-search">
                    <span className="ic"><BiSearch/></span>
                    <input type="text" placeholder={t(`rvPlaceHd`)} onChange={handleSearch}/>
                </div>
                <div className="rv-top-spacer"/>
                <Link to={"/UserReviewWritePg"}>
                    <button className="up-btn-primary" style={{height: "44px", padding: "0 22px", fontSize: "14px"}}>{t(`rvdtBt`)}</button>
                </Link>
            </div>

            {/*후기카드 그리드 — UserHome.js 이용후기 카드(uh-review)와 완전히 동일*/}
            <div className="rvp-grid uh-review-grid-rvp">
                {filteredReviews.slice(0, displayLimit).map((review, index) => {
                    const hasPhoto = review && review.reviewPhotoDTO[0] && review.reviewPhotoDTO[0].fileNm;
                    return (
                        <div key={index} className="uh-review" onClick={() => navigate(`/UserReviewDetailPg/${review.seqNum}`)}>
                            <div className={`uh-review-thumb ${hasPhoto ? "" : "is-empty"}`}>
                                {newTextPrintFl(review.regDate) && <span className="uh-review-new">New</span>}
                                {hasPhoto ?
                                    <img alt="" src={"https://toeloperfile.s3.ap-northeast-2.amazonaws.com/reviewPhoto/" + review.reviewPhotoDTO[0].fileNm}/>
                                    :
                                    <img alt="" src={noReviewPhoto}/>
                                }
                            </div>
                            <div className="uh-review-body">
                                <p className="uh-review-tag">[{review.country}-{review.shipco}]</p>
                                <p className="uh-review-title">{review.title}</p>
                                <p className="uh-review-date">{formatDate(review.regDate)}</p>
                            </div>
                        </div>
                    );
                })}
            </div>

            <div style={{width: "100%", textAlign: "center"}}>
                {
                    (!hasClickedMore && filteredReviews.length === displayLimit) ||
                    (hasClickedMore && displayLimit < reviewAllList.length) ?
                        <button className="rv-more" onClick={handleMore}>+ More</button>
                        : null
                }
            </div>
        </div>
    );
}

export default UserReviewPg
